import React from "react";

export const NetworkStatusLabel = ({ inNetwork }) => (
  <span className={inNetwork ? "text-success" : "text-danger"}>{inNetwork ? "In-Network" : "Out-of-Network"}</span>
);
